<template>
  <div class="status-badge"
       :class="`status-${object.status}`">
    {{ $t(object.status) }}
  </div>
</template>

<script setup>
defineProps({
  object: {
    type: Object
  }
})
</script>
